import { DateFilterModel } from '@/models/date-filter.model';
import { IS_SWEDEN } from '@/constants/constants';

const getDateRangeBetweenDays = (today: Date, daysStart: number, daysEnd: number) => {
  const fromDate = new Date();
  fromDate.setUTCDate(today.getDate() + daysStart - 1);
  const toDate = new Date(today);
  toDate.setUTCDate(today.getDate() + daysEnd + 1);
  return {
    fromDate: fromDate.toISOString().split('T')[0],
    toDate: toDate.toISOString().split('T')[0],
  };
};

export const dateFilterOptionsPerMonth = (
  now: Date,
  locale: string,
): Record<number, DateFilterModel> => {
  const currentMonth = now.getMonth();
  return Array(13)
    .fill(null)
    .map((_, i) => i)
    .reduce((a: Record<number, DateFilterModel>, i) => {
      const d = new Date(now);
      d.setMonth(currentMonth - i);
      const label = d.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'short',
      });
      const firstDayOfMonth = new Date(d.getFullYear(), d.getMonth(), 1);
      firstDayOfMonth.setMinutes(
        firstDayOfMonth.getMinutes() - firstDayOfMonth.getTimezoneOffset(),
      );
      const lastDayOfMonth = new Date(d.getFullYear(), d.getMonth() + 1, 1);
      lastDayOfMonth.setMinutes(lastDayOfMonth.getMinutes() - lastDayOfMonth.getTimezoneOffset());
      const toDate = i === 0 ? d : lastDayOfMonth;

      return {
        ...a,
        [i + 1]: {
          label,
          dateRange: {
            fromDate: firstDayOfMonth.toISOString().split('T')[0],
            toDate: toDate.toISOString().split('T')[0],
          },
          skipIntl: true,
        },
      };
    }, {});
};

export const DEFAULT_HISTORY_FILTER: Record<number, DateFilterModel> = {
  1: {
    dateRange: getDateRangeBetweenDays(new Date(), -30, 0),
    label: 'history.filter.last30days',
  },
  2: {
    dateRange: getDateRangeBetweenDays(new Date(), -60, -30),
    label: 'history.filter.3060days',
  },
  3: {
    dateRange: getDateRangeBetweenDays(new Date(), -90, -60),
    label: 'history.filter.6090days',
  },
  4: {
    dateRange: getDateRangeBetweenDays(new Date(), -120, -90),
    label: 'history.filter.90120days',
  },
  5: {
    dateRange: getDateRangeBetweenDays(new Date(), -150, -120),
    label: 'history.filter.120150days',
  },
  6: {
    dateRange: getDateRangeBetweenDays(new Date(), -180, -150),
    label: 'history.filter.150180days',
  },
};

export const getDateFilterOptions = (): Record<number, DateFilterModel> => {
  if (IS_SWEDEN) return dateFilterOptionsPerMonth(new Date(), 'sv-SE');
  return DEFAULT_HISTORY_FILTER;
};

export const mapDateFilterItems = (items: Record<number, DateFilterModel>) =>
  Object.keys(items)
    .map(key => +key)
    .map(key => ({
      id: `${key}`,
      translationId: !items[key].skipIntl ? items[key].label : undefined,
      text: items[key].skipIntl ? items[key].label : undefined,
      props: items[key].dateRange,
    }));
